import { render } from "./AgeSelectWithRange.vue?vue&type=template&id=0cdaaed2&ts=true"
import script from "./AgeSelectWithRange.vue?vue&type=script&lang=ts"
export * from "./AgeSelectWithRange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/CT/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__